import { render, staticRenderFns } from "./ReflectionInfo.vue?vue&type=template&id=0d507237&scoped=true&"
import script from "./ReflectionInfo.vue?vue&type=script&lang=js&"
export * from "./ReflectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionInfo.vue?vue&type=style&index=0&id=0d507237&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d507237",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
